import {
  FilterMode,
  SignedEdition_OrderBy,
  SignedEdition,
  SortOrder,
  SignedEdition_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";

export const signedEditionService = {
  createOne: () => (): Promise<string> => new Promise(() => ""),

  signedEditionDndaWorkflow_ExpirarUploadKeyDuranteUpload: async (
    instanceId: string,
    instanceVersion: string,
    instanceEntity: string,
    token: string,
    activityStore: any
  ) => {
    const api = getApiInstance(token, activityStore);
    const result =
      await api.signedEditionDndaWorkflow_ExpirarUploadKeyDuranteUpload({
        instanceId,
        instanceVersion,
        instanceEntity,
      });
    return result.signedEditionDndaWorkflow_ExpirarUploadKeyDuranteUpload;
  },

  signedEditionDndaWorkflow_ReintentarGeneracionEjemplar: async (
    instanceId: string,
    instanceVersion: string,
    instanceEntity: string,
    token: string,
    activityStore: any
  ) => {
    const api = getApiInstance(token, activityStore);
    const result =
      await api.signedEditionDndaWorkflow_ReintentarGeneracionEjemplar({
        instanceId,
        instanceVersion,
        instanceEntity,
      });
    return result.signedEditionDndaWorkflow_ReintentarGeneracionEjemplar;
  },

  signedEditionDndaWorkflow_ReintentarRegistroDnda: async (
    instanceId: string,
    instanceVersion: string,
    instanceEntity: string,
    token: string,
    activityStore: any
  ) => {
    const api = getApiInstance(token, activityStore);
    const result = await api.signedEditionDndaWorkflow_ReintentarRegistroDnda({
      instanceId,
      instanceVersion,
      instanceEntity,
    });
    return result.signedEditionDndaWorkflow_ReintentarRegistroDnda;
  },

  signedEditionDndaWorkflow_ReintentarUploadEjemplar: async (
    instanceId: string,
    instanceVersion: string,
    instanceEntity: string,
    token: string,
    activityStore: any
  ) => {
    const api = getApiInstance(token, activityStore);
    const result = await api.signedEditionDndaWorkflow_ReintentarUploadEjemplar(
      { instanceId, instanceVersion, instanceEntity }
    );
    return result.signedEditionDndaWorkflow_ReintentarUploadEjemplar;
  },

  signedEditionDndaWorkflow_ReintentarAvanceRegistro: async (
    instanceId: string,
    instanceVersion: string,
    instanceEntity: string,
    token: string,
    activityStore: any
  ) => {
    const api = getApiInstance(token, activityStore);
    const result = await api.signedEditionDndaWorkflow_ReintentarAvanceRegistro(
      { instanceId, instanceVersion, instanceEntity }
    );
    return result.signedEditionDndaWorkflow_ReintentarAvanceRegistro;
  },

  signedEditionDndaWorkflow_ReintentarAvanceUpload: async (
    instanceId: string,
    instanceVersion: string,
    instanceEntity: string,
    token: string,
    activityStore: any
  ) => {
    const api = getApiInstance(token, activityStore);
    const result = await api.signedEditionDndaWorkflow_ReintentarAvanceUpload({
      instanceId,
      instanceVersion,
      instanceEntity,
    });
    return result.signedEditionDndaWorkflow_ReintentarAvanceUpload;
  },

  signedEditionSadaicWorkflow_ReintentarSubidaSadaic: async (
    instanceId: string,
    instanceVersion: string,
    instanceEntity: string,
    token: string,
    activityStore: any
  ) => {
    const api = getApiInstance(token, activityStore);
    const result = await api.signedEditionSadaicWorkflow_ReintentarSubidaSadaic(
      { instanceId, instanceVersion, instanceEntity }
    );
    return result.signedEditionSadaicWorkflow_ReintentarSubidaSadaic;
  },
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.signedEditionOne({ id });
    return result.signedEditionOne as SignedEdition;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: SignedEdition_OrderBy[] | null = null,
    filter: SignedEdition_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: SignedEdition_Filter | undefined;
    if (searchValue !== "") {
      where = { id: { contains: searchValue, mode: FilterMode.Insensitive } };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.signedEditionListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : { id: SortOrder.Asc },
      where,
    });
    const list = nullToUndefinedRecursive(
      result.signedEditionListWithOffset
    ) as SignedEdition[];
    return { list, orderBy };
  },
};
